import React from 'react';
import { IoCloseSharp } from 'react-icons/io5';
import { ReactComponent as CloudUpload } from '../../assets/icons/cloud-upload.svg';
import { DropZoneComponentProps } from '../form-controls/FileUpload/FileUpload';
import { Spinner } from '../Spinners/Spinner';

export const DropZoneComponent: React.FC<DropZoneComponentProps> = ({
  files,
  imgFile,
  uploadState,
  deleteFile,
}) => (


  <div className="border border-dashed rounded-lg border-gray-300 w-full h-44 flex flex-col justify-center items-center">
    {uploadState.loading && (
      <div>
        <Spinner color="#666" />
      </div>
    )}
    {!uploadState.loading && (
      <>
        {imgFile ? (
          <img src={imgFile} className="max-h-full" alt="" />
          //   <div className="flex w-full flex-wrap justify-center h-full items-start p-2"> 
          //     {files?.map((file) => (
          //     <div key={file} className="h-full px-2 relative">
          //       <button
          //         className="absolute cursor-pointer right-0 top-0"
          //         onClick={(e) => deleteFile(e, file)}
          //         type="button"
          //       >
          //         <IoCloseSharp className="text-lg" />
          //       </button>
          //       <img src={file} key={file} className="max-h-full" alt="" />
          //     </div>
          //   ))}
          // </div> 
        ) : (
          <div className="flex flex-col items-center justify-center">
            <div className="mb-6">
              <CloudUpload />
            </div>
            <p className="text-xs text-secondary">Upload an image</p>
            <button
              type="button"
              className="text-gray-300 font-medium border-gray-300 border rounded px-5 py-2 my-4 text-sm"
            >
              Choose file
            </button>
          </div>
        )}
        {/* {!files.length && 
            <img src={imgFile} className="max-h-full" alt="" />
        } */}
      </>
    )}
  </div>
);
